import React, { Suspense } from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/client';
import { AppConfig, AppConfigService, AppService } from '@aperza/util';
import ReactDOM from 'react-dom';
import { Header } from '@aperza/header-footer';
import UserSection from '../user/UserSection';
import NavBar from '../navbar/NavBar';
import SearchResultBar from '../searchResult/SearchResultBar';
const QUERY = gql `
  query HeaderLoaderQuery($params: String!) {
    viewer {
      id
      aperzaId
      userId
      cartBadge {
        approvalFlag
        totalPurchaseNumber
      }
      mailAddress
      photoUrl
      firstName
      lastName
      searchModel(params: $params) {
        count
      }
      searchItem(params: $params) {
        count
      }
      searchCatalog(params: $params) {
        count
      }
      searchNews(params: $params) {
        count
      }
      ...UserSection_viewer
      ...NavBar_viewer
    }
  }
  ${UserSection.fragments.viewer}
  ${NavBar.fragments.viewer}
`;
const HeaderLoader = (props) => {
    const appConfig = AppService.appConfig();
    const { loading, error, data, refetch } = useQuery(QUERY, {
        variables: {
            params: JSON.stringify(AppConfigService?.getSearchParams() || {}),
        },
    });
    if (loading)
        return React.createElement("div", null);
    if (!loading || data) {
        const initEl = document.getElementById('aperza-header-init');
        if (initEl) {
            initEl.style.display = 'none';
        }
    }
    // TODO : clean up old header (AB-20530)
    const headerProps = {
        ...AppConfigService.resolveHeaderConfigurations(),
        ...props,
    };
    const doRefetch = () => {
        if (refetch) {
            return refetch({
                params: JSON.stringify(AppConfigService?.getSearchParams() || {}),
            });
        }
    };
    switch (appConfig.serviceType) {
        case AppConfig.APERZA_EC:
        case AppConfig.APERZA_ORDER:
        case AppConfig.APERZA_BIZ: {
            const keyword = AppConfigService.getSearchKeyword();
            return (React.createElement(Header, { user: data.viewer, unreadMessageCount: data.viewer.unreadMessageCount, type: AppConfig.APERZA_EC, fixed: true }, keyword && React.createElement(SearchResultBar, { viewer: data.viewer })));
        }
        case AppConfig.APERZA_SEARCH: {
            const keyword = AppConfigService.getSearchKeyword();
            return (React.createElement(Header, { user: data.viewer, type: appConfig.serviceType, unreadMessageCount: data.viewer.unreadMessageCount, fixed: true }, keyword && React.createElement(SearchResultBar, { viewer: data.viewer })));
        }
        default:
            break;
    }
    return (React.createElement(Header, { user: data.viewer, unreadMessageCount: data.viewer.unreadMessageCount, type: appConfig.serviceType, fixed: true }));
};
const renderHeader = (apolloClient) => {
    const appConfig = AppService.appConfig();
    const headerElement = document.getElementById('aperza-header');
    if (headerElement) {
        const headerWrapperElement = document.getElementById('aperza-header-wrapper');
        if (headerWrapperElement) {
            headerWrapperElement.style.position = 'sticky';
            headerWrapperElement.style.top = '0px';
            headerWrapperElement.style.zIndex = '1020';
        }
        // dirty fix
        // override `overflow-x: hidden` from body preventing from sticky scroll
        if (appConfig.serviceType === AppConfig.APERZA_CATALOG) {
            const bodyElement = document.body;
            bodyElement.style.overflow = 'initial';
        }
        if (appConfig.serviceType === AppConfig.APERZA_EC) {
            const bodyElement = document.body;
            bodyElement.style.height = 'auto';
            bodyElement.style.minHeight = '100%';
        }
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(HeaderLoader, null))), headerElement);
    }
};
export { HeaderLoader, renderHeader };
